/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, inject } from '@angular/core';
import {PlatformStorage} from '@app/core/tokens/platform-storage.token';
import {AbstractSecurityStorage} from 'angular-auth-oidc-client';

@Injectable()
export class SecurityStorageService implements AbstractSecurityStorage {
  private readonly storage = inject(PlatformStorage);

  read(key: string): string | null {
    return this.storage.getItem(key);
  }

  write(key: string, value: any): void {
    this.storage.setItem(key, value);
  }

  remove(key: string): void {
    this.storage.removeItem(key);
  }

  clear(): void {
    this.storage.clear();
  }
}
